// "View all" in the Shop By block below the product grid shows the rest of
// that column's links in place. Every link is already in the HTML, so this
// only changes what is visible.
document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.shop_by_column .read_more_link');

    if (toggle) {
        expand(toggle);
    }
});

// The toggle is an <a> without an href (as the site's other read-more links
// are), so it needs Enter and Space by hand to behave like a button
document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
        return;
    }

    const toggle = event.target.closest?.('.shop_by_column .read_more_link');

    if (toggle) {
        event.preventDefault(); // stop Space scrolling the page
        expand(toggle);
    }
});

function expand(toggle) {
    const column = toggle.closest('.shop_by_column');

    column.classList.add('expanded');
    toggle.setAttribute('aria-expanded', 'true');

    // The toggle hides itself, so move focus on to the first link it revealed
    column.querySelector('.shop_by_more a')?.focus();
}
